module.exports = __webpack_public_path__ + "img/w3_cart_white.b832d9b5.png";